var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_vm._t("label", function () {
    return [_c('p', {
      staticClass: "p1",
      class: _vm.$style.label
    }, [_vm._v(" " + _vm._s(_vm.label) + ": "), _vm.isRequired ? _c('span', {
      class: _vm.$style.requiredAsterisk,
      attrs: {
        "data-required-asterisk": ""
      }
    }, [_vm._v("*")]) : _vm._e()])];
  }), _vm.subLabel && _vm.editMode ? _c('p', {
    class: _vm.$style.formItemSubLabel
  }, [_vm._v(_vm._s(_vm.subLabel))]) : _vm._e(), !_vm.editMode ? [_vm.value.length ? _c('ul', {
    class: _vm.$style.valuesList
  }, _vm._l(_vm.value, function (item) {
    return _c('li', {
      key: item
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }), 0) : _c('h4', {
    class: _vm.$style.value
  }, [_vm._v(_vm._s('N/A'))])] : _vm._e(), _vm.editMode ? [_c('ValidationProvider', {
    ref: "checkboxValidationProvider",
    attrs: {
      "immediate": _vm.immediateValidation,
      "debounce": 300,
      "name": _vm.label,
      "rules": _vm.rules
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_vm._l(_vm.editCheckboxValues, function (checkboxValue) {
          return _c('div', {
            key: checkboxValue,
            class: _vm.$style.checkboxContainer
          }, [_c('BaseCheckbox', {
            class: _vm.$style.checkboxItem,
            attrs: {
              "label": checkboxValue,
              "input-value": checkboxValue,
              "disabled": _vm.disabled || _vm.disabledCheckboxValues.includes(checkboxValue)
            },
            on: {
              "input": _vm.onInput
            },
            model: {
              value: _vm.modelValue,
              callback: function callback($$v) {
                _vm.modelValue = $$v;
              },
              expression: "modelValue"
            }
          }), _vm.checkboxSubLabels[checkboxValue] && _vm.editMode ? _c('p', {
            class: _vm.$style.formItemCheckboxSubLabel,
            domProps: {
              "innerHTML": _vm._s(_vm.checkboxSubLabels[checkboxValue])
            }
          }) : _vm._e()], 1);
        }), errors[0] ? _c('p', {
          staticClass: "tag-text",
          class: _vm.$style.errorMessage
        }, [_vm._v(_vm._s(errors[0]))]) : _vm._e()];
      }
    }], null, false, 2859375747)
  })] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }